import { HttpService, TaggedUrl, Tags, transformDTODate } from '@skylab-shared/core';
import { DataExchangeStatus } from '@skylab-shared/dataModel';
import { fillPlaceholders } from '@skylab-shared/utils';
import { Transform } from 'class-transformer';
import { AccountancyMessage, AccountancyValidation } from '../../../accountancy/queries/accountancy-grid.query-base';
import { EventNotification, EventNotificationType, EventNotificationsServiceBase } from '../../event-notifications.service-base';
import { NotificatorBase } from '../notificator-base';

type DataExchangeStatusEventData = EventNotification<{id: number}>;

export type DataExchangeStatusItem = DataExchangeStatusItemDTO;

class DataExchangeStatusItemDTO {
    public id: number;
    public status: DataExchangeStatus;
    public messages: AccountancyMessage[];
    public attachments: string[];
    public validations: AccountancyValidation[];
    @Transform(transformDTODate, { toClassOnly: true }) public generated: Date;
};

export class DataExchangeStatusNotificatorBase extends NotificatorBase<DataExchangeStatusEventData, DataExchangeStatusItem[]> {
    protected eventType: EventNotificationType[] = ['NexoDdkStatusUpdated', 'JpkGenerationStatusUpdated', 'EppGenerationStatusUpdated', 'PackageOfDocumentsGenerationStatusUpdated'];
    private readonly url = TaggedUrl.join('accounting/:id', [Tags.Api, Tags.OmitMessage]);

    public constructor(
        eventNotifications: EventNotificationsServiceBase,
        http: HttpService
    ) {
        super(eventNotifications, http);
    }

    protected async prepareDataAsync(events: DataExchangeStatusEventData[]): Promise<DataExchangeStatusItem[]> {
        const ids = events.map(elem => +elem.properties!.id);
        const statuses = await this.getStatusesAsync(ids);
        return statuses;
    }

    private async getStatusesAsync(ids: number[]): Promise<DataExchangeStatusItem[]> {
        const requests = ids.map(id => this.getStatusRequest(id));
        const data = await Promise.all(requests);
        return data;
    }

    private async getStatusRequest(id: number): Promise<DataExchangeStatusItem> {
        const url = fillPlaceholders(this.url, { id: id });
        const { data } = await this.http.get(url, {dto: DataExchangeStatusItemDTO});
        return {
            id: data.id,
            status: data.status,
            messages: data.messages,
            validations: data.validations,
            attachments: data.attachments,
            generated: data.generated
        };
    }
}
